import React, {useEffect, useState} from "react";
import {Head, Loading, UserAutocomplete} from "../../components";
import {Box, Tooltip} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort";
import moment from "moment-jalaali";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {marketers, updateMarketersStatus} from "../../actions";
import {useNavigate} from "react-router";
import MarketerExcelDownload from "./excel";
import {DatePicker} from "zaman";
import CurrencyFormat from "react-currency-format";
import MarketerLink from "../../components/Marketer/Name";
import ButtonGroup from "@mui/material/ButtonGroup";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";

const Marketer = () => {

    const AppState = useSelector(state => state);

    const dispatch = useDispatch();
    const history = useNavigate();

    const [page, setPage] = useState(1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(50);
    const [filter, setFilter] = useState({
        status: 1
    });
    const [loading, setLoading] = useState(false);
    const [searchTime, setSearchTime] = useState("");

    useEffect(() => {
        if (AppState.marketer.ready !== 'success') {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [AppState.marketer.ready]);


    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, filter, page]);

    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {

            let search = filter;

            search[event.target.name] = event.target.value;

            setFilter({...search});

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(() => {

                let search = filter;

                search[name] = word;

                setFilter({...search})

            },500);

            setSearchTime(loop);
        }


    }

    const handleRequest = () => {

        dispatch(marketers({
            filter,
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        }));

    };



    const handleChangeMarketerStatus = (event , id) => {
        setLoading(true);
        dispatch(updateMarketersStatus({
            id: id,
            obj:{
                "form": "marketer_change_status",
                "status": event.target.value
            }
        }));

    };



    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        let search = filter;

        search[name] = value;

        setFilter({...search})

    }

    const handleGetMIMT = (id) => {

        setLoading(true);

        new Api().put('/marketers/' + id + '/getMarketerCode').then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleRequest();
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }
        })
    }
    const pageCount = Math.ceil(parseInt(AppState.marketer.response.total) / parseInt(AppState.marketer.response.per_page));

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت بازاریابان', 'description': 'کاربران را مدیریت کنید' }} />
            <Box mb={5}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography>جستجو در لیست</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="نام"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="name"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="نام خانوادگی"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="family"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    label="موبایل"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="mobile"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    label="ایمیل"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="email"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="username"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    label="کد ملی"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="national_code"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    type={"search"}
                                    label="کد بازاریابی"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="marketer_code"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete
                                    label={"دایرکت"}
                                    onChange={(value) =>
                                        handleChangeSearchInputWithAutoComplete("parent_id", value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete
                                    label={"زیرمجموعه"}
                                    onChange={(value) =>
                                        handleChangeSearchInputWithAutoComplete("hr", value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    select
                                    type={"search"}
                                    label="کد وزارت"
                                    variant="outlined"
                                    value={filter.is_code}
                                    margin="dense"
                                    fullWidth
                                    name="is_code"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>
                                        انتخاب
                                    </MenuItem>
                                    <MenuItem key={1} value={1}>
                                        دارد
                                    </MenuItem>
                                    <MenuItem key={2} value={0}>
                                        ندارد
                                    </MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    select
                                    type={"search"}
                                    label="وضعیت"
                                    variant="outlined"
                                    value={filter.status}
                                    margin="dense"
                                    fullWidth
                                    name="status"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>
                                        انتخاب
                                    </MenuItem>
                                    <MenuItem key={1} value={1}>
                                        فعال
                                    </MenuItem>
                                    <MenuItem key={2} value={0}>
                                        غیرفعال
                                    </MenuItem>
                                    <MenuItem key={3} value={2}>
                                        تعلیق
                                    </MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <div className="datepicker-input-container">
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            handleChangeSearchInputWithAutoComplete(
                                                "from_date",
                                                moment(value.value).locale("en").format("YYYY/MM/DD HH:mm:ss")
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <div className="datepicker-input-container">
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            handleChangeSearchInputWithAutoComplete(
                                                "to_date",
                                                moment(value.value).locale("en").format("YYYY/MM/DD HH:mm:ss")
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button color="primary">جستجو</Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                {AppState.marketer.response.total > 0 && <div><span>نمایش</span>&nbsp;<span><b>{AppState.marketer.response.from}</b>&nbsp;<span>تا</span>&nbsp;<b>{AppState.marketer.response.to}</b>&nbsp;<span>از</span>&nbsp;<b>{AppState.marketer.response.total}</b></span>&nbsp;<span>مورد</span></div>}
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    <MarketerExcelDownload object={{
                        filter,
                        sort_field: sort_field,
                        sort_type: sort_type,
                        page: page,
                        limit: limit
                    }}/>
                    <Tooltip title="سینک" onClick={() => handleRequest()}>
                        <IconButton>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th onClick={() => { setSortField('id'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th>نام و نام خانوادگی</th>
                        <th>نام کاربری</th>
                        <th>موبایل</th>
                        <th>کد ملی</th>
                        <th>کد وزارت</th>
                        <th>کد بازاریابی</th>
                        <th>بالاسری</th>
                        <th>لاین</th>
                        <th>زیرمجموعه</th>
                        <th onClick={() => { setSortField('created_at'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>تاریخ ثبت نام&nbsp;{sort_field === 'created_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => { setSortField('status'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {AppState.marketer.response.data && AppState.marketer.response.data.map((marketer, index) => {
                        return(
                            <tr key={index}>
                                <td>{marketer.id}</td>
                                <td><MarketerLink user={marketer.user} /></td>
                                <td>{marketer.user.username ? marketer.user.username : '-'}</td>
                                <td>{marketer.user.mobile}</td>
                                <td>{marketer.info ? marketer.info.national_code : '-' }</td>
                                <td>{marketer.info && marketer.info.gov_code  ? marketer.info.gov_code : <Button onClick={() => handleGetMIMT(marketer.id)} size={"small"} color={"secondary"} variant={"outlined"} >دریافت کد</Button> }</td>
                                <td>{marketer.marketer_code}</td>
                                <td>{marketer.parent ? marketer?.user?.name + ' ' + marketer?.user?.family : ''}</td>
                                <td>{marketer.position}</td>
                                <td><CurrencyFormat value={marketer.subset} displayType="text" thousandSeparator /></td>
                                <td style={{ direction: 'ltr'}}>{moment(marketer.user.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td>
                                    <TextField
                                        select={marketer.status}
                                        type={"search"}
                                        variant="outlined"
                                        value={filter.is_code}
                                        size={"small"}
                                        defaultValue={marketer.status}
                                        name='is_code'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(event) => handleChangeMarketerStatus(event , marketer.id)}
                                    >
                                        <MenuItem key={0} value={0}>غیرفعال</MenuItem>
                                        <MenuItem key={1} value={1}>فعال</MenuItem>
                                        <MenuItem key={3} value={3}>تایید نشده</MenuItem>
                                    </TextField>
                                </td>
                                <td>
                                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                                        <Button onClick={() => history('/marketer/' + marketer.id)} color={"primary"} variant={"outlined"} size={"medium"}>ویرایش</Button>&nbsp;
                                        <Button onClick={() => history('/orders/?user_id=' + marketer.id)} color={"primary"} variant={"outlined"} size={"medium"}>سفارشات</Button>&nbsp;
                                        <Button onClick={() => history('/marketer/deposits/' + marketer.id)} color={"primary"} variant={"outlined"} size={"medium"}>پاداش ها</Button>&nbsp;
                                    </ButtonGroup>

                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
        </div>
    );

}

export default Marketer;